/* istanbul ignore file */
/**
 * Created by rathompson on 12/17/21
 * File: LicenseReducer.actions.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// Action Types
export const LOAD_LICENSE = 'LOAD_LICENSE'
export const LOAD_CSP_ACCOUNTS = 'LOAD_CSP_ACCOUNTS'
export const LOAD_LICENSE_INSTANCES = 'LOAD_LICENSE_INSTANCES'
export const SET_ACTIVATE_LOADING = 'SET_ACTIVATE_LOADING'
export const SET_NEW_TSG_LOADING = 'SET_NEW_TSG_LOADING'
export const LOAD_USER_INSTANCES = 'LOAD_USER_INSTANCES'
export const SET_USER_FLOW = 'SET_USER_FLOW'
export const SET_USER_MESSAGE = 'SET_USER_MESSAGE'
export const MERGE_USER_CSP_ACCOUNT = 'MERGE_USER_CSP_ACCOUNT'

export const loadLicense = (licenseDetails) => ({
  type: LOAD_LICENSE,
  licenseDetails
})

export const loadCSPAccounts = (cspResponse, isFramework) => ({
  type: LOAD_CSP_ACCOUNTS,
  cspResponse,
  isFramework
})

export const loadInstances = (instanceResponse) => ({
  type: LOAD_LICENSE_INSTANCES,
  instanceResponse
})

export const loadUserInstances = (instances) => ({
  type: LOAD_USER_INSTANCES,
  instances
})

export const setActivateLoading = (loading) => ({
  type: SET_ACTIVATE_LOADING,
  loading
})
export const setNewTsgLoading = (loading) => ({
  type: SET_NEW_TSG_LOADING,
  loading
})

export const setUserFlow = (userFlow) => ({
  type: SET_USER_FLOW,
  userFlow
})

export const setLicenseMessage = (message, isError = false) => ({
  type: SET_USER_MESSAGE,
  isError: isError,
  message
})
export const mergeUserCSPAccountInfo = (userCSPAccounts) => ({
  type: MERGE_USER_CSP_ACCOUNT,
  userCSPAccounts
})

